import React from 'react';
import { Container, Tabs, Tab } from 'react-bootstrap'
import Header from '../Header/Header';
import PageBanner from '../page-banner/page-banner';
import VoteItem from '../vote-item/vote-item';

import "./voting.css";

function Farms() {
	return (
		<>
			<Header />
			<section className="earn-section">
				<PageBanner title="Voting" subHeading="Have your say in the future of the PanCardanoSwap Ecosystem" />
			</section>
			<section className="voting-area content-section">
				<Container>
					<h2 className="mb-3">Proposals</h2>
					<div className="voting-tabs-holder">
						<Tabs defaultActiveKey="core" id="uncontrolled-tab-example" className="mb-3">
							<Tab eventKey="core" title="Core">
								<div className="radios-holder py-3 d-flex">
									<div className="me-3">
										<label className="custom-circular-radio">Vote Now
											<input type="radio" name="core-radio" />
											<span className="checkmark"></span>
										</label>
									</div>
									<div className="me-3">
										<label className="custom-circular-radio">Soon
											<input type="radio" name="core-radio" />
											<span className="checkmark"></span>
										</label>
									</div>
									<div className="me-3">
										<label className="custom-circular-radio">Closed
											<input type="radio" name="core-radio" />
											<span className="checkmark"></span>
										</label>
									</div>
								</div>
								<div className="vote-items">
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" core={true} voteNow={true}/>
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" core={true} />
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" core={true} closed={true} />
								</div>
							</Tab>
							<Tab eventKey="community" title="Community">
								<div className="radios-holder py-3 d-flex">
									<div className="me-3">
										<label className="custom-circular-radio">Vote Now
											<input type="radio" name="community-radio" />
											<span className="checkmark"></span>
										</label>
									</div>
									<div className="me-3">
										<label className="custom-circular-radio">Soon
											<input type="radio" name="community-radio" />
											<span className="checkmark"></span>
										</label>
									</div>
									<div className="me-3">
										<label className="custom-circular-radio">Closed
											<input type="radio" name="community-radio" />
											<span className="checkmark"></span>
										</label>
									</div>
								</div>
								<div className="vote-items">
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" community={true} voteNow={true}/>
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" community={true} />
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" community={true} closed={true} />
								</div>
							</Tab>
							<Tab eventKey="all" title="All">
								<div className="radios-holder py-3 d-flex">
									<div className="me-3">
										<label className="custom-circular-radio">Vote Now
											<input type="radio" name="all-radio" />
											<span className="checkmark"></span>
										</label>
									</div>
									<div className="me-3">
										<label className="custom-circular-radio">Soon
											<input type="radio" name="all-radio" />
											<span className="checkmark"></span>
										</label>
									</div>
									<div className="me-3">
										<label className="custom-circular-radio">Closed
											<input type="radio" name="all-radio" />
											<span className="checkmark"></span>
										</label>
									</div>
								</div>
								<div className="vote-items">
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" core={true} voteNow={true}/>
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" core={true} />
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" core={true} closed={true} />
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" community={true} voteNow={true}/>
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" community={true} />
									<VoteItem title="Proposal for a Beta Finance Syrup Pool and Farm" date="Oct 7th, 2021" time="15:00" community={true} closed={true} />
								</div>
							</Tab>
						</Tabs>
					</div>
				</Container>
			</section>
		</> 
	);
}

export default Farms;
